// extracted by mini-css-extract-plugin
export default {"container":"lRX8SS","column":"p7XG0t","row":"gKcB6L"};